export default "__VITE_ASSET__DG_Y8EgI__"